<template>
  <CDropdown
    :label="t('sort_by')"
    :options="dropdownOptions"
    :value="selected"
    @update:model-value="changeSorting($event)"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type Props = {
  sortOrder?: string;
};

const props = withDefaults(defineProps<Props>(), {
  sortOrder: '',
});

const emit = defineEmits<{
  (e: 'change-sorting', payload: string): void;
}>();

const { t } = useI18n();
const route = useRoute();

const selected = ref('rel');
const sortOptions = ref([
  { name: t('relevance'), value: 'rel' },
  { name: t('a_to_z'), value: 'asc' },
  { name: t('z_to_a'), value: 'desc' },
]);

const dropdownOptions = computed(() => sortOptions.value.map(({ name, value }) => ({ label: name, value })));

const changeSorting = (e: string) => {
  selected.value = e;
  emit('change-sorting', selected.value === 'rel' ? '' : selected.value);
};

watch(
  () => route,
  () => {
    selected.value = 'rel';
  },
);

watch(
  () => props.sortOrder,
  (newSortOrder) => {
    if (newSortOrder === 'rel') selected.value = newSortOrder;
    else if (newSortOrder === '') selected.value = 'rel';
    else selected.value = newSortOrder;
  },
  { immediate: true },
);
</script>

<script lang="ts">
export default defineComponent({
  name: 'SortProducts',
});
</script>
